import { BodyText, Heading } from '@postscript/components';
import DisplayCard from '../Layout/DisplayCard';
import {
  StyledBlockHeading,
  StyledCardGrid,
  StyledPullQuote,
} from '../Layout/SimpleStyledComponents';
import SystemBlock from '../Layout/SystemBlock';

const PrinciplesSection = (): JSX.Element => {
  return (
    <SystemBlock id="design-principles">
      <StyledBlockHeading>
        <Heading as="h2" size="small">
          Design principles
        </Heading>
        <BodyText size="large">
          As we grow the Postscript Design team and evangelize within the
          company, we&apos;ve aligned on a set of design principles to help us
          understand the fundamental traits that make our team successful. Along
          with the Design System, our principles help us make decisions quickly
          and confidently, measure our results, and guide our focus.
        </BodyText>
      </StyledBlockHeading>
      <StyledCardGrid desktopColumns={2}>
        <DisplayCard
          heading="As simple as SMS"
          description="Designs should feel as easy, familiar, and effective as sending
  a text."
          emoji="mobile-phone"
          size="medium"
        />
        <DisplayCard
          heading="Make bets"
          description="It's okay not to know everything. A small, strategic bet
      could be the next breakthrough. Ship quickly and measure the
      results."
          emoji="game-die"
          size="medium"
        />
        <DisplayCard
          heading="Rock solid, but not set in stone"
          description="Use established patterns and components first, but be adaptable
      and unafraid to let customer insights challenge convention."
          emoji="rock"
          size="medium"
        />
        <StyledPullQuote>
          <blockquote cite="https://abookapart.com/products/expressive-design-systems">
            Design principles are a set of guidelines your team can follow
            throughout their design process in order to create more aligned
            experiences. Well-written design principles create alignment, speed
            up decision-making, and increase the quality of your team&apos;s
            output.
          </blockquote>
          <figcaption>
            <span>Yesenia Perez-Cruz</span>
            <cite>
              <em>Expressive Design Systems</em>
            </cite>
          </figcaption>
        </StyledPullQuote>
      </StyledCardGrid>
    </SystemBlock>
  );
};

export default PrinciplesSection;
